import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecordEvent } from './useRecordEvent';

const MAX_EVENT_NAME_LENGTH = 50;

function getEventName(pathname: string): string {
  const parts = pathname.split('/').filter(Boolean);
  const basePath = 'view:/' + parts.slice(0, 3).join('/');
  return basePath.slice(0, MAX_EVENT_NAME_LENGTH);
}

export function usePageViewRecording(): void {
  const location = useLocation();
  const { recordEvent } = useRecordEvent();
  const previousPathReference = useRef<string | null>(null);

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    const referrer = previousPathReference.current || '';
    previousPathReference.current = currentPath;

    recordEvent({
      name: getEventName(location.pathname),
      url: currentPath,
      title: document.title,
      referrer,
      data: { path: currentPath },
    });
  }, [location.pathname, location.search, recordEvent]);
}
